import React,  {Component} from 'react'; 
import MovieTimesPeriodeDays from './MovieTimesPeriodeDays'
import MovieTimeTheatreContainer from './MovieTimesTheatreContainer'
import getBrowserWidth from '../functions/getBrowserWidth'
import Translation from '../General/Translation';
import PerformancePerCinemaFilters from './PerformancePerCinemaFilters';
import MovieTimesCinemaContainer from './MovieTimesCinemaContainer';
import MovieTimesMobileContainer from './MovieTimesMobileContainer';
import getMomentNow from '../functions/getMomentNow';
import setMomentDateObjZero from '../functions/setMomentDateObjZero';
import getTranslationTime from '../functions/getTranslationTime';
import { MULTICINEMA } from '../constants/multiCinemaModes';
import MovieTimesCinemaMobileContainer from './MovieTimesCinemaMobileContainer';
import CountdownContainer from './CountdownContainer';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';
import withUseCountdown from '../hooks/withUseCountdown';

class MovieTimes extends Component {
    constructor (props) {
        super(props) 
        this.state = {
            isMobile: false
        }

        this.updateDimensions = this.updateDimensions.bind(this)
    }
    
    componentDidMount() {
        this.updateDimensions()
        this.debouncedUpdateDimensions = _.debounce(this.updateDimensions, 300)
        window.addEventListener("resize", this.debouncedUpdateDimensions)
    }

    componentWillUnmount() {
        this.debouncedUpdateDimensions.cancel()
        window.removeEventListener("resize", this.debouncedUpdateDimensions)
    }

    updateDimensions() {
        const isMobile = getBrowserWidth() >= 480 ? false : true

        if(isMobile !== this.state.isMobile) {
            this.setState({
                isMobile: isMobile
            })
        }
    }    


    render() {
        const { 
            movieData, 
            currentDateActive, 
            filterType, 
            filterValue, 
            activePerformance, 
            scrollToPosition, 
            onClick,   
            additionalClass = '', 
            onOpenIframe, 
            containsVorschau, 
            movieTimesDesktop, 
            movieTimesMobile, 
            queryStringValues, 
            translation, 
            performancePageMovieTimes=false, 
            purchaseblePerformances,
            activeCinema,
            clusterCinemaOption,
            clusterCinemaName,
            fullyfilteredPerformance,
            clusterCinemas,
            countdownNumbers,
            movieTimesOpen,
            toggleShowtimes,
            clusterCinemaActive,
            cinemas,
            currentCinemaType,
            currentCinemaPk,
            setActiveCinema,
            hideCinemaSelector=false
        } = this.props
        const { isMobile } = this.state
        const { timezone, locale } = translation
        const today = setMomentDateObjZero(getMomentNow(timezone))
        //TESTING COUNTDOWN!!!
        // const today = setMomentDateObjZero(getMomentDateObj(1711120780000, timezone))
        const { pk, title, startingDate, limitations, alternativeLinks } = movieData
        const {visibleFrom, showCountdown} = limitations
        const formatedDate =  visibleFrom ? getTranslationTime('performanceDates', translation, visibleFrom) : startingDate ? getTranslationTime('performanceDates', translation, startingDate) : null
        const showTimesSortedAfterTheaterClass = movieTimesDesktop && movieTimesDesktop === 'theater_sorted' ? 'theater-sorting' : ''
        const timeFilterIsSet = queryStringValues && queryStringValues.time && queryStringValues.time !== 'week' ? true : false
        const performanceFilterIsSet = checkPerformanceFilterIsSet(filterType, filterValue, queryStringValues, containsVorschau)
        const showMovietimes = performancePageMovieTimes ? movieTimesOpen ? true : false : true
        const hintText = (purchaseblePerformances[0] && fullyfilteredPerformance[0]) ? <Translation id="selectTime" trans={translation}>Uhrzeit auswählen</Translation> : ((formatedDate || visibleFrom) && !purchaseblePerformances[0]) ? ((showCountdown && visibleFrom) || (!showCountdown)) ? <span><Translation id="availableFrom" trans={translation}>Verfügbar ab</Translation> {formatedDate}</span> : '' : <span><Translation id="noPerformances" trans={translation}>Keine Spielzeiten verfügbar.</Translation></span>
       
        if(!purchaseblePerformances || Object.keys(purchaseblePerformances) === 0) {
            return ''
        } else {
            return (
                <div className={"movie-times-wrapper" + additionalClass}>
                    {isMobile && performancePageMovieTimes && <button className='change-movie-times buy-ticket-large button text-light cursor-pointer' onClick={() => toggleShowtimes()}><Translation id="changeTime" trans={translation}>Uhrzeit ändern</Translation></button>}
                    {(clusterCinemaOption || currentCinemaType === MULTICINEMA) && !hideCinemaSelector && showMovietimes && <PerformancePerCinemaFilters 
                        clusterCinemaOption={clusterCinemaOption}
                        activeCinema={activeCinema}
                        clusterCinemaName={clusterCinemaName}
                        currentCinemaType={currentCinemaType}
                        clusterCinemas={clusterCinemas}
                        setActiveCinema={setActiveCinema}
                        cinemas={cinemas}
                        translation={translation}
                        currentCinemaPk={currentCinemaPk}
                    />}
                    <div className='ticket-hint-container'>
                        {showMovietimes && <p className= "buy-ticket-hint text-large-bold">{hintText}</p>}
                        {(formatedDate || visibleFrom) && showCountdown && !purchaseblePerformances[0] && <div className='countdown-wrapper'>
                            <CountdownContainer translation={translation} countdownNumbers={countdownNumbers}/>
                        </div>}
                    </div>
                    <div className={"movie-times " + showTimesSortedAfterTheaterClass}>
                        {showMovietimes && (isMobile && ((clusterCinemaOption && clusterCinemaActive) || (currentCinemaType === MULTICINEMA && clusterCinemaActive)) ? (
                            <MovieTimesCinemaMobileContainer
                                movieId={pk}
                                movieTitle={title}
                                performances={fullyfilteredPerformance} 
                                onClick={onClick} 
                                today={today} 
                                currentDateActive={currentDateActive} 
                                alternativeLinks={alternativeLinks}
                                activePerformance={activePerformance}
                                isMobile={isMobile} 
                                scrollToPosition={scrollToPosition}
                                onOpenIframe={onOpenIframe}
                                queryStringValues={queryStringValues}
                                toggleShowtimes={toggleShowtimes}
                            />
                        ) : isMobile && movieTimesMobile === "day_filter_wheel" ? (
                            <MovieTimesMobileContainer 
                                movieId={pk}
                                movieTitle={title}
                                performances={fullyfilteredPerformance} 
                                onClick={onClick} 
                                today={today} 
                                alternativeLinks={alternativeLinks && alternativeLinks[activeCinema]}
                                currentDateActive={currentDateActive} 
                                activePerformance={activePerformance}
                                isMobile={isMobile} 
                                scrollToPosition={scrollToPosition}
                                onOpenIframe={onOpenIframe}
                                queryStringValues={queryStringValues}
                                toggleShowtimes={toggleShowtimes}
                            />
                        ) : (clusterCinemaOption && clusterCinemaActive) || (currentCinemaType === MULTICINEMA && clusterCinemaActive) ? (
                            <MovieTimesCinemaContainer
                                movieId={pk}
                                movieTitle={title}
                                performances={fullyfilteredPerformance} 
                                activePerformance={activePerformance}
                                today={today} 
                                alternativeLinks={alternativeLinks}
                                scrollToPosition={scrollToPosition}
                                onOpenIframe={onOpenIframe}
                                queryStringValues={queryStringValues} 
                            />
                        ) : movieTimesDesktop === "standard" || timeFilterIsSet || performanceFilterIsSet || isMobile && movieTimesMobile === "standard" ? (
                            <MovieTimesPeriodeDays 
                                movieId={pk}
                                movieTitle={title}
                                performances={fullyfilteredPerformance} 
                                onClick={onClick} 
                                today={today} 
                                currentDateActive={currentDateActive} 
                                activePerformance={activePerformance}
                                alternativeLinks={alternativeLinks && alternativeLinks[activeCinema]}
                                isMobile={isMobile} 
                                scrollToPosition={scrollToPosition}
                                onOpenIframe={onOpenIframe}
                                toggleShowtimes={toggleShowtimes}
                            />
                        ) : (
                            <MovieTimeTheatreContainer 
                                movieId={pk}
                                movieTitle={title}
                                performances={fullyfilteredPerformance} 
                                activePerformance={activePerformance}
                                alternativeLinks={alternativeLinks && alternativeLinks[activeCinema]}
                                today={today} 
                                scrollToPosition={scrollToPosition}
                                onOpenIframe={onOpenIframe} 
                                queryStringValues={queryStringValues} 
                            />
                        ))}
                    </div>
                </div>
            )
        }
    }
}

export default withUseCountdown(MovieTimes)